export default __webpack_public_path__ + "static/media/backgound_pink.7a99ae2d.jpg";